import {
  FcHeader,
  ConsentBannerAndConsentManagement,
} from '@common/ui';
import { FcFooter } from '@common/ui/src/footer/FcFooter';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export const BaseLayout = () => {
  const location = useLocation();

  const isPublicPage =
    location.pathname.includes('approbation-habilitation') ||
    location.pathname === '/mentions-legales' ||
    location.pathname === '/politique-confidentialite' ||
    location.pathname.includes('deconnexion');

  return (
    <main>
      <FcHeader
        hideLogoutButtonAndNavigation={isPublicPage}
      />

      <div style={{ backgroundColor: '#f0f0f0' }}>
        <Outlet />
      </div>

      <ConsentBannerAndConsentManagement />
      <FcFooter appVersion={__APP_VERSION__} />
    </main>
  );
};